<template>
  <div class="menu-global-item">
    <slot></slot>
  </div>
</template>

<script lang="ts">

import {defineComponent} from 'vue';

export default defineComponent({
  name: 'MenuGlobalItemSection',
  components: {},
});

</script>

<style lang="scss">

$check-circle: "%3Csvg class='svg-inline--fa fa-check-circle fa-w-16' fill='%23babdcd' aria-hidden='true' focusable='false' data-prefix='fas' data-icon='check-circle' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath class='' fill='23FFFFFF' d='M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z'%3E%3C/path%3E%3C/svg%3E";
$circle: "%3Csvg class='svg-inline--fa fa-circle fa-w-16' aria-hidden='true' fill='%23babdcd' focusable='false' data-prefix='fal' data-icon='circle' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath class='' d='M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z'%3E%3C/path%3E%3C/svg%3E";

.menu-global-item {
  margin-bottom: var(--space-8);
  display: flex;
  justify-content: center;

  .c-workspace {
    display: flex;
    width: 100%;
    position: relative;
    cursor: pointer;
    &:hover {
      .c-border {
        background-color: var(--border-neutral-dark);
      }

      .c-image {
        background-color: var(--light-100);
      }
    }
    .c-border{
      mask-image: url("data:image/svg+xml,%3Csvg clip-rule='evenodd' fill-rule='evenodd' viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m18.947 18.947c-13.32 13.32-17.947 42.57-17.947 109.053s4.626 95.732 17.947 109.053c13.32 13.32 42.57 17.947 109.053 17.947s95.732-4.626 109.053-17.947c13.32-13.32 17.947-42.57 17.947-109.053s-4.626-95.732-17.947-109.053c-13.32-13.32-42.57-17.947-109.053-17.947s-95.732 4.626-109.053 17.947z' fill-rule='nonzero' stroke='%23000' transform='matrix(.992126 0 0 .992126 1.00787 1.00787)'/%3E%3C/svg%3E");
      background-color: var(--border-neutral-dark);
      width: 40px;
      height: 40px;
      min-width: 40px;
      min-height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover{
        background-color: var(--border-neutral);
        box-shadow: var(--shadow-outline);
      }
    }
    .c-image {
      min-width: 38px;
      min-height: 38px;
      max-width: 38px;
      max-height: 38px;
      background-color: var(--light-100);
      border-radius: $br-sm;
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--text-neutral);
      font-size: var(--fs-16);
      font-weight: 600;
      mask-image: url("data:image/svg+xml,%3Csvg clip-rule='evenodd' fill-rule='evenodd' viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m18.947 18.947c-13.32 13.32-17.947 42.57-17.947 109.053s4.626 95.732 17.947 109.053c13.32 13.32 42.57 17.947 109.053 17.947s95.732-4.626 109.053-17.947c13.32-13.32 17.947-42.57 17.947-109.053s-4.626-95.732-17.947-109.053c-13.32-13.32-42.57-17.947-109.053-17.947s-95.732 4.626-109.053 17.947z' fill-rule='nonzero' stroke='%23000' transform='matrix(.992126 0 0 .992126 1.00787 1.00787)'/%3E%3C/svg%3E");
      mask-position: center center;
      mask-repeat: no-repeat;

      img {
        width: 40px;
        height: 40px;
        border-radius: $br-sm;
      }
    }

    .c-name {
      display: flex;
      width: 100%;
      flex-grow: 1;
      text-align: left;
      overflow: hidden;
      outline: none;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      z-index: 1;
      font-size: var(--fs-14);
      line-height: 20px;

      span:first-child {
        font-size: var(--fs-14);
        font-weight: 600;
        text-align: left;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        width: 95%;
      }

      span:nth-of-type(2) {
        font-size: var(--fs-12);
        color: var(--text-neutral);
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        width: 95%;
      }
    }

    .c-arrow {
      margin-left: auto;
      margin-right: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--text-blue);

      .arrow-right {
        color: var(--text-neutral);
      }

      &.check {
        &:before {
          content: '';
          background-repeat: no-repeat;
          display: block;
          width: 15px;
          height: 15px;
        }
      }
    }
  }

  .btn-circle {
    background-color: var(--cyan-200);
    border-color: var(--cyan-200);
    color: var(--light-100);
    font-weight: 600;
    mask-image: url("data:image/svg+xml,%3Csvg clip-rule='evenodd' fill-rule='evenodd' viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m18.947 18.947c-13.32 13.32-17.947 42.57-17.947 109.053s4.626 95.732 17.947 109.053c13.32 13.32 42.57 17.947 109.053 17.947s95.732-4.626 109.053-17.947c13.32-13.32 17.947-42.57 17.947-109.053s-4.626-95.732-17.947-109.053c-13.32-13.32-42.57-17.947-109.053-17.947s-95.732 4.626-109.053 17.947z' fill-rule='nonzero' stroke='%23000' transform='matrix(.992126 0 0 .992126 1.00787 1.00787)'/%3E%3C/svg%3E") !important;
    mask-position: center center !important;
    mask-repeat: no-repeat !important;
    border: 0;

    &:hover {
      color: var(--light-100);
      background-color: var(--cyan-200);
      border-color: var(--cyan-200);
    }

    &.circle-user {
      width: 40px;
      height: 40px;
      padding: 0;

      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 40px;
        height: 40px;
      }
    }


  }

  .btn-notification {
    width: 50px;
    height: 50px;
    font-size: var(--fs-20);
    padding: 5px 10px;
    border-radius: $br-circle !important;
    color: var(--text-dark);

    &:hover {
      background-color: var(--neutral-100);
      color: var(--text-dark);
      border-radius: $br-circle !important;
    }

    .notification-alert {
      position: absolute;
      color: var(--light-100);
      background-color: var(--red-100);
      border-radius: $br-circle;
      font-size: var(--fs-12);
      width: 20px;
      height: 20px;
      padding: 2px;
      top: 14px;
      right: 2px;
      font-weight: 600;
    }
  }

  .dropdown-menu {
    border: 0;
    font-size: var(--fs-14);

    .dropdown-menu-box{
      padding: var(--space-4) !important;
    }

    &.dropdown-notification {
      min-width: 400px;
      width: 400px;
      top: 0 !important;
      left: 64px !important;
      height: 100vh;
      position: fixed !important;
      z-index: 1;
      transform: none !important;
      border-radius: 0 !important;

      .dropdown-menu-box{
        padding: 20px !important;
        border-radius: 0px !important;
        height: 100%;
        background-color: var(--light-100);
      }

      .tab-content {
        padding: 10px 0;

        .notification-header {
          font-size: var(--fs-12);
          text-transform: uppercase;
          color: var(--text-neutral);
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;

          .btn-read {
            font-size: var(--fs-10);
            color: var(--text-neutral);
            padding: 5px 0;

            &:hover {
              color: var(--black-color-300)
            }
          }
        }

        .notification-item {
          display: flex;
          cursor: pointer;
          padding: 5px;
          margin-bottom: 10px;

          &.active {
            font-weight: 600;

            .notification-action {
              .btn-notification-read {
                background-color: var(--accent-100);
                box-shadow: var(--shadow-md);
              }
            }
          }

          &:hover {
            background-color: var(--light-200);
            border-radius: $br-sm;

            .notification-action {
              .btn-notification-clear {
                display: flex;
              }

              .btn-notification-read {
                box-shadow: var(--shadow-md);
              }
            }
          }

          .notification-img {
            width: 35px;
            height: 35px;
            border-radius: $br-circle;
            background-color: var(--neutral-200);
            margin-right: 10px;
            font-weight: 600;
            font-size: var(--fs-14);
            display: flex;
            justify-content: center;
            align-items: center;
            color: var(--light-100);

            img {
              width: 35px;
              height: 35px;
              border-radius: $br-circle;
            }

            span {
              width: 35px;
              height: 35px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }

          .notification-text {
            font-size: var(--fs-14);

            .notification-project {
              display: block;
              margin-bottom: 3px;
              margin-top: 3px;

              svg {
                margin-right: 3px;
              }

              a {
                color: var(--accent-100);
                font-weight: 400;

                &:hover {
                  text-decoration: underline;
                }
              }
            }

            .notification-day {
              display: block;
              font-weight: 300;
              font-size: var(--fs-12);
              color: var(--text-neutral);
            }
          }

          .notification-action {
            display: flex;
            justify-content: flex-end;
            width: 80px;
            padding: 5px;
            margin-left: auto;

            .btn-notification-clear {
              padding: 0;
              width: 10px;
              height: 10px;
              font-size: var(--fs-14);
              display: none;
              justify-content: center;
              align-items: center;
              color: var(--text-neutral);
              padding: 0 15px;

              &:hover {
                color: var(--black-color-300)
              }
            }

            .btn-notification-read {
              width: 10px;
              height: 10px;
              border-radius: $br-circle;
              padding: 0;

              &:hover {
                background-color: var(--accent-100);
                box-shadow: var(--shadow-md);
              }
            }
          }
        }
      }
    }
  }

  .dropdown-item {
    padding: var(--space-8);
    cursor: pointer;

    svg {
      margin-right: 5px;
    }

    &:active,
    &:hover {
      background-color: var(--light-200);
      color: var(--black-color-300)
    }

    &.package {
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: var(--fs-12);
        border: 1px solid var(--neutral-400);
        border-radius: $br-sm;
        color: var(--neutral-400);
        text-transform: uppercase;
        padding: 3px 6px;
        font-weight: 600;
      }
    }

    &.dropdown-workspace {
      &.active {
        background-color: var(--item-grey-bg-hover);
        border: 1px solid var(--item-grey-border-hover);
        color: var(--text-dark);

        .c-arrow.check {
          &:before {
            content: '';
            background-image: url("data:image/svg+xml, #{$check-circle}") !important;
          }
        }
      }

    }
  }

  .dropdown-divider {
    border-top: 1px solid var(--border-light);
    margin: var(--space-4) !important;
  }

  .no-notification-alert {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: var(--text-neutral);

    p {
      color: var(--text-neutral);
      margin: var(--space-0);
    }

    svg {
      font-size: var(--fs-32);
      margin: 20px 0;
    }
  }
}

</style>
